import React, { useRef } from 'react';
import styled, { css } from '../../styled';
import * as Tooltip from '../tooltip';
import Text from '../text';
import { Cross } from '../icons/outline/Cross';
import { ExclamationMark } from '../icons/outline/ExclamationMark';
import { ImageUpload } from '../imageUpload';
const StyledImageUpload = styled(ImageUpload) `
  height: 100%;
  width: 100%;
  position: absolute;
`;
const ImageUploadWrapper = styled.div `
  display: ${({ shouldShow }) => (shouldShow ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  border-radius: ${({ theme, borderRadius }) => theme.showImage.borderRadius[borderRadius]};
`;
const ImageUploadContainer = styled.div `
  height: 4.75rem;
  width: 18.5rem;
  text-align: center;
`;
const generateIconWrapper = () => css `
  z-index: 2;
  width: 2.5rem;
  height: 2.5rem;
  position: absolute;
  right: 0;
  top: 0;
`;
const ExclamationMarkIconWrapper = styled.div `
  ${() => generateIconWrapper()};
`;
const CrossIconWrapper = styled.div `
  ${() => generateIconWrapper()};
  :hover {
    background-color: ${({ theme }) => theme.colors.PRIMARY_A400};
  }
`;
const CrossIconInnerWrapper = styled.div `
  padding: 0.5rem;
  :hover {
    > div > div > svg {
      fill: ${({ theme }) => theme.colors.RED_600};
    }
  }
`;
const ImageIconWrapper = styled.div `
  height: 2rem;
`;
const Title = styled(Text) `
  padding: 0.25rem 0;
  display: block;
`;
const Description = styled(Text) ``;
const ImageWrapper = styled.div `
  ${props => props.imageSource &&
    css `
      background-image: url(${props.imageSource});
    `};
  width: 100%;
  height: 100%;
  border-radius: ${({ theme, borderRadius }) => theme.showImage.borderRadius[borderRadius]};
  background-position: center;
  background-size: cover;
`;
const generateWrapperStyle = (props) => {
    const { hasImageSource, isError } = props;
    if (isError) {
        return css `
      border: 1px dashed ${({ theme }) => theme.colors.RED_600};
    `;
    }
    if (hasImageSource) {
        return css `
      :hover {
        ${ImageUploadWrapper} {
          display: flex;
          z-index: 1;
          background-color: ${({ theme }) => theme.colors.SNOW_A900};
        }
        ${Description} {
          color: ${({ theme }) => theme.colors.INK_500};
        }
      }
    `;
    }
    if (!hasImageSource) {
        return css `
      border: 1px dashed ${({ theme }) => theme.colors.INK_300};
      :hover {
        ${ImageUploadWrapper} {
          display: flex;
          z-index: 1;
          background-color: ${({ theme }) => theme.colors.PRIMARY_A200};
        }
        border-color: ${({ theme }) => theme.colors.PRIMARY_400};
        color: ${({ theme }) => theme.colors.PRIMARY_600};
        ${Title} {
          color: ${({ theme }) => theme.colors.PRIMARY_600};
        }
        ${Description} {
          color: ${({ theme }) => theme.colors.PRIMARY_600};
        }
        ${ImageIconWrapper} {
          > svg {
            fill: ${({ theme }) => theme.colors.PRIMARY_600};
          }
        }
      }

      :active {
        border: none;
        color: ${({ theme }) => theme.colors.PRIMARY_500};
        ${ImageUploadWrapper} {
          background-color: ${({ theme }) => theme.colors.PRIMARY_A400};
        }
        ${Title} {
          color: ${({ theme }) => theme.colors.PRIMARY_500};
        }
        ${Description} {
          color: ${({ theme }) => theme.colors.PRIMARY_500};
        }
        ${ImageIconWrapper} {
          > svg {
            fill: ${({ theme }) => theme.colors.PRIMARY_500};
          }
        }
      }
    `;
    }
    return null;
};
const Wrapper = styled.div `
  position: relative;
  box-sizing: border-box;
  height: ${props => props.height}px;
  width: ${props => props.width}px;
  border-radius: ${({ theme, borderRadius }) => theme.showImage.borderRadius[borderRadius]};
  cursor: pointer;
  ${props => generateWrapperStyle(props)}
`;
const ShowImage = ({ width, height, borderRadius = 'none', Icon, onChange, onError, title, description, tooltipMessage, lang, imageSource, onRemoveClick, isError = false, errorTooltipMessage, }) => {
    const inputRef = useRef(null);
    const onCrossIconClick = () => {
        if (inputRef && inputRef.current) {
            // @ts-ignore
            inputRef.current.value = '';
            onRemoveClick();
        }
    };
    return (React.createElement(Wrapper, { hasImageSource: !!imageSource, width: width, height: height, borderRadius: borderRadius, isError: isError },
        React.createElement(StyledImageUpload, { onChange: onChange, onError: onError, ref: inputRef, render: (onFileInputClick) => (React.createElement(React.Fragment, null,
                React.createElement(ImageUploadWrapper, { shouldShow: !imageSource, onClick: onFileInputClick, borderRadius: borderRadius },
                    React.createElement(ImageUploadContainer, null,
                        React.createElement(ImageIconWrapper, null,
                            React.createElement(Icon, { size: "XXLARGE" })),
                        React.createElement(Title, { fontType: "Body", color: "INK_600", lang: lang }, title),
                        React.createElement(Description, { fontType: "Caption", color: "INK_400", lang: lang }, description))),
                imageSource && !isError && (React.createElement(CrossIconWrapper, { onClick: onCrossIconClick },
                    React.createElement(CrossIconInnerWrapper, null,
                        React.createElement(Tooltip.Primary, { lang: lang, text: tooltipMessage, direction: "TOP_CENTER" },
                            React.createElement(Cross, { size: "LARGE" }))))),
                isError && (React.createElement(ExclamationMarkIconWrapper, { onClick: onCrossIconClick },
                    React.createElement(CrossIconInnerWrapper, null,
                        React.createElement(Tooltip.Primary, { lang: lang, text: errorTooltipMessage, direction: "TOP_CENTER" },
                            React.createElement(ExclamationMark, { size: "LARGE", color: "RED_600" }))))))) }),
        imageSource && (React.createElement(ImageWrapper, { imageSource: imageSource, borderRadius: borderRadius }))));
};
export default ShowImage;
//# sourceMappingURL=ShowImage.js.map